<template>
  <div 
    class="js-scroll-animation-unit"
    :class="{
      'is-animated': isAnimated
    }">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      offset: {
        type: Number,
        default: () => {
          return 0.67 // 0 - 1
        }
      },
    },
    data() {
      return {
        isAnimated: false,
        unwatch: null,
      }
    },
    computed: {
    },
    created() {
      this.unwatch = this.$watch('$window.scrollY', () => {
        if(this.$el.getBoundingClientRect().top <= this.$window.height * this.offset) {
          this.unwatch()

          this.$nextTick(() => {
            this.isAnimated = true  
          })
        }
      })
    },
    mounted() {
    },
    beforeDestroy() {
      this.unwatch && this.unwatch()
    },
    methods: {
    }
  };
</script>


// WEBPACK FOOTER //
// src/plugins/scroll-animation-unit/component.vue